import React, { Component } from "react";
import SimpleHeader from "../../../base/features/blocks/SimpleHeader";
import { apiService } from "../../../base/utils/service";
import Spinner from "../../../base/features/micro/Spinner";
import Image from "../../../base/features/micro/Image";
import { Link } from "react-router-dom";
import CardModal from "./blocks/CardModal";
import OptionsModal from "./blocks/OptionsModal";
import DynamicView from "../../dynamicView/DynamicView";

class Payments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      card: "",
      onSpot: false,
      cardModal: false,
      optionsModal: false,
      gateways: null,
      shopUid: window.location.pathname.split("/")[2],
      views: null,
    };
  }

  componentDidMount() {
    this.getPaymentConfig();
  }
  getPaymentConfig() {
    apiService(`v1/shops/${this.state.shopUid}/payment-config`, "get").then(
      (data) => {
        if (data) {
          this.setState({
            onSpot: data.on_spot,
            card: data.card,
            gateways: data.gateways,
            views: data.views,
          });
        }
      }
    );
  }
  updatePayment(card) {
    this.setState({ inputPending: true });
    var params;
    if (card) {
      params = {
        on_spot: this.state.onSpot,
        card: card,
      };
    } else {
      params = {
        on_spot: !this.state.onSpot,
        card: this.state.card,
      };
    }
    console.log(params);
    apiService(
      `v1/shops/${this.state.shopUid}/payment-config`,
      "put",
      params,
      true
    ).then((data) => {
      if (
        data &&
        data.response &&
        data.response.status &&
        data.response.status === 400 &&
        data.response.data.errors.card
      ) {
        this.setState({
          cardError: data.response.data.errors.card,
        });
      }
      if (data && data.card) {
        this.setState({
          cardModal: false,
          cardError: null,
          card: data.card,
          onSpot: data.on_spot,
        });
      }
      this.setState({ inputPending: false });
    });
  }
  updateOptions(gateway, g) {
    this.setState({ inputPending: true });
    var params = {
      authority_1: gateway.shop_config.authority_1,
      authority_2: gateway.shop_config.authority_2,
      authority_3: gateway.shop_config.authority_3,
      index: 0,
      active: !gateway.shop_config.active,
      gateway: gateway.uid,
    };
    apiService(
      `v1/shops/${this.state.shopUid}/payment-config/gateways/${gateway.shop_config.uid}`,
      "put",
      params
    ).then((data) => {
      if (data) {
        var old_gateways = this.state.gateways;
        old_gateways[g].shop_config.active = data.active;
        this.setState({ gateways: old_gateways });
      }
      this.setState({ inputPending: false });
    });
  }
  render() {
    return (
      <div className="container-fluid px-0">
        <SimpleHeader text="شیوه های پرداخت" />
        {this.state.gateways ? (
          <body style={{ marginTop: "80px" }}>
            {this.state.views && this.state.views.header && (
              <DynamicView viewPage="shopHome" view={this.state.views.header} />
            )}
            <div className="row mx-0 p-4 border-bottom">
              <div className="col-auto px-0">
                <img
                  alt="location"
                  src={
                    require("../../../base/assets/icons/location.svg").default
                  }
                />
              </div>
              <div className="col px-3">
                <p className="mb-0 fs-5 fw-bold">پرداخت در محل</p>
              </div>
              <div className="col-auto px-0" style={{ zIndex: "3" }}>
                <input
                  disabled={this.state.inputPending}
                  className="form-check-input"
                  style={{ width: "20px", height: "20px" }}
                  value={this.state.onSpot}
                  checked={this.state.onSpot}
                  onChange={() => this.updatePayment()}
                  type="checkbox"
                />
              </div>
            </div>
            <div className="row mx-0 p-4 border-bottom">
              <div className="col-auto px-0">
                <img
                  alt="credit-card"
                  src={
                    require("../../../base/assets/icons/creditCard.svg").default
                  }
                />
              </div>
              <div className="col px-3">
                <p className="mb-0 fs-5 fw-bold">کارت به کارت</p>
                <p className="mb-2 small text-muted fw-bold">
                  {this.state.card}
                </p>

                {this.state.cardModal && (
                  <CardModal
                    cardError={this.state.cardError}
                    cardModal={this.state.cardModal}
                    changeModal={(e) => this.setState({ cardModal: e })}
                    cardNumber={this.state.card}
                    cardNumberChange={(e) => this.updatePayment(e)}
                  />
                )}
              </div>
              <div className="col-auto px-0" style={{ zIndex: "3" }}>
                <p
                  onClick={() => this.setState({ cardModal: true })}
                  className="mb-0 color-main fw-bold"
                >
                  ویرایش
                </p>
              </div>
            </div>
            {this.state.views && this.state.views.under_cart && (
              <DynamicView
                viewPage="shopHome"
                view={this.state.views.under_cart}
              />
            )}
            {this.state.gateways.map((gateway, g) => (
              <div className="row mx-0 p-4 border-bottom position-relative">
                <div className="col-auto px-0">
                  <Image
                    imageUri={gateway.cover && gateway.cover.thumbnail}
                    imgClassName={`rounded7`}
                    imageWidth={"35"}
                    imageHeight={"35"}
                    extraClassName="d-block rounded7 p-2 mx-auto bg-secondary"
                  />
                </div>
                <div className="col px-3">
                  <p className="mb-0 fs-5 fw-bold">{gateway.title}</p>
                  <p className="mb-2 small text-muted fw-bold">
                    {gateway.shop_config ? "متصل شده" : "متصل نشده"}
                  </p>
                  <p
                    onClick={() =>
                      this.setState({ gateway: gateway, optionsModal: true })
                    }
                    className="mb-0 color-main fw-bold"
                  >
                    تنظیمات
                  </p>
                </div>
                <div
                  className="col-auto px-0"
                  onClick={() =>
                    !gateway.shop_config &&
                    this.setState({ gateway: gateway, optionsModal: true })
                  }
                  style={{ zIndex: "3" }}
                >
                  <input
                    disabled={this.state.inputPending || !gateway.shop_config}
                    className="form-check-input"
                    style={{ width: "20px", height: "20px" }}
                    value={gateway.shop_config && gateway.shop_config.active}
                    checked={gateway.shop_config && gateway.shop_config.active}
                    onChange={() => this.updateOptions(gateway, g)}
                    type="checkbox"
                  />
                  <Link
                    to={`/${gateway.uid}`}
                    className="position-absolute"
                    style={{ bottom: "25px", left: "25px" }}
                  >
                    <span className="small fw-bold color-main">{`معرفی درگاه ${gateway.title}`}</span>
                  </Link>
                </div>
              </div>
            ))}
            {this.state.optionsModal && (
              <OptionsModal
                cardError={this.state.cardError}
                gateway={this.state.gateway}
                optionsModal={this.state.optionsModal}
                changeModal={(e) => this.setState({ optionsModal: e })}
                optionsChange={(data) => {
                  let old_gateways = this.state.gateways;
                  let new_gateways = [];
                  old_gateways.map((item, i) => {
                    if (item.uid === data.gateway) {
                      let new_item = item;
                      new_item.shop_config = data;
                      new_gateways.push(new_item);
                    } else {
                      new_gateways.push(item);
                    }
                  });
                  console.log(new_gateways);
                  this.setState({ gateways: new_gateways });
                }}
              />
            )}
            {this.state.views && this.state.views.footer && (
              <DynamicView viewPage="shopHome" view={this.state.views.footer} />
            )}
          </body>
        ) : (
          <div style={{ marginTop: "80px" }}>
            <Spinner />
          </div>
        )}
      </div>
    );
  }
}

export default Payments;
